import React, { useEffect, useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux'
import API from '../../../../utils/API';
import MesTable from '../../../../components/Table/MesTable';
import constants from '../../../../utils/constants';
import commonMethods from '../../../../utils/common-methods';
import useInfiniteScroll from '../../../../components/common/useInfiniteScroll';
import { FormattedMessage } from 'react-intl';
import SignageReceivers from './SignageReceivers';
function SignageHistoryTable(props) {
  const { updateFlag, onLoadHistoryTable } = props;
  const [data, setData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedIds, setSelectedIds] = useState({});
  const [sortByCol, setSortByCol] = useState('dateAndTime');
  const [sortByAsc, setSortByAsc] = useState(false);
  const [startIndexForTable, setStartIndexForTable] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [receivers, setReceivers] = useState([]);

  const tableRef = useRef();
  const tableWrapperRef = useRef();

  const [historyData, setHistoryData] = useState([]);

  const loadHistoryTable = async (map, resetSelection = true) => {
    map.data = {};
    map.ids = [];
    map.sortedIds = [];
    map.filteredIds = [];
    if (resetSelection) {
      map.selectedIds = {};
    }

    try {
      const res = await API.getSignageHistory();
      res.data.forEach((mess) => {
        const scheduled = commonMethods.formatScheduler(mess.scheduler);

        map.data[mess.id] = {
          id: mess.id,
          title: mess.title,
          scheduled,
          groups: Array.isArray(mess.groups) 
            ? mess.groups.map((o) => o.name).join(', ')
            : mess.groups?.name || '',
          createdBy: `${mess.createdBy?.firstName || ''} ${mess.createdBy?.lastName || ''}`,
          dateAndTime: mess.timeStart ? commonMethods.formatDate(mess.timeStart) : '',
          status: mess.status,
          failedReceivers: mess.failedReceivers,
          receivers: mess.receivers,
          checked: false,
          cmses: mess.cmses
        };
      });
      map.filteredIds = Object.keys(map.data);
      map.ids = Object.keys(map.data);
      setDataCount(map.ids.length);
      setHistoryData(res.data);
      setTotalDataCount(map.ids.length);
      setDataLoaded(true);
    } catch (err) {
      setDataLoaded(true);
      // If it's error 502, skip error handling
      if (err.response && err.response.status === 502)
        return;
      if (err.response?.data?.error) {
        return;
      }
      setError(err.message);
    }
  };

  useEffect(() => {
    if (onLoadHistoryTable) {
      onLoadHistoryTable(() => {
        loadHistoryTable(dataMap)
      });
    }
  }, [onLoadHistoryTable]);

  const dataMap = useMemo(() => {
    const map = { data: {}, ids: [], selectedIds: {}, filteredIds: [], sortedIds: [] };
    loadHistoryTable(map);
    return map;
  }, []);

  // Hook for infinite scrolling
  const { generateDataSlice, sortMap, setSortBy } = useInfiniteScroll({
    dataMap,
    setData,
    setStartIndexForTable,
    startIndexForTable,
    pageSize: 100,
    sortByCol,
    setSortByCol,
    sortByAsc,
    setSortByAsc,
    tableWrapperRef,
    searchValue,
    tableRef,
    rowHeight: 48,
  });

  // Hook for sorting data when data changes or sort column is changed
  useEffect(() => {
    if (dataLoaded) {
      if (searchValue !== '') {
        tableRef.current.search(dataMap);
      } else {
        sortMap(dataMap);
        setData(generateDataSlice(dataMap));
      }
    }
  }, [sortByCol, sortByAsc, dataLoaded, dataMap, historyData]);

  useEffect(() => {
    loadHistoryTable(dataMap);
  }, [updateFlag]);

  function handleViewReceiversClick(receivers) {
    setReceivers(receivers);
  }

  const tableColumnArray = [
    {
      Header: 'SIGNAGE',
      id: 'title',
      accessor: 'title',
      isVisible: true,
    },
    {
      Header: 'SCHEDULED',
      id: 'scheduled',
      accessor: 'scheduled',
      isVisible: true,
    },
    {
      Header: 'GROUPS',
      id: 'groups',
      isVisible: true,
      accessor: 'groups',
    },
    {
      Header: 'CREATED_BY',
      id: 'createdBy',
      isVisible: true,
      accessor: 'createdBy',
    },
    {
      Header: 'DATE_AND_TIME',
      id: 'dateAndTime',
      isVisible: true,
      accessor: 'dateAndTime',
    },
    {
      Header: 'DELIVERY',
      id: 'status',
      accessor: 'status',

      isVisible: true,
    },
    {
      Header: '',
      id: 'viewReceivers',
      Cell: ({ row }) => (
        <div
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#signageReceiversModal"
          onClick={() => { handleViewReceiversClick(row.original.receivers) }}
          className="link-button"
          style={{ cursor: 'pointer', gap: 8 }}
        >
          <FormattedMessage id="VIEW_RECEIVERS" />
        </div>
      ),
      isVisible: true,
    },
  ];

  const tableProps = {
    pageType: constants.pageType.SignageHistory,
    modalId: "SignageHistory",
    columns: tableColumnArray,
    data, setData,
    dataMap,
    generateDataSlice,
    sortMap,
    dataCount, setDataCount,
    totalDataCount,
    setSortBy,
    sortByCol,
    sortByAsc,
    success, setSuccess,
    error, setError,
    startIndex: startIndexForTable,
    selectedIds, setSelectedIds,
    searchValue,
    setSearchValue,
    tableRef,
    tableWrapperRef,
    dataLoaded,
    initialContainerHeight: '288px',
  };

  return (
    <div>
      <SignageReceivers receivers={receivers} />
      <MesTable {...tableProps} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(SignageHistoryTable);
